<template>
  <v-app>
    <v-main>
      <v-container>
        <loading
          v-model:active="isLoading"
          :can-cancel="false"
          loader="dots"
          color="#007bff"
          :height="45"
          :width="75"
          :is-full-page="true"
          background-color="#fff"
          :opacity="1"
        ></loading>
        <img
          :src="logo"
          style="width: 203px !important; height: 33px !important"
          alt="Logo"
        />
        <br />
        <a
          @mouseover="isHoveringPrintDetails = true"
          @mouseleave="isHoveringPrintDetails = false"
          :class="
            isHoveringPrintDetails
              ? 'link-color set-font'
              : 'underline set-font'
          "
          @click="printDetail"
          >Print Details</a
        >
        &nbsp;
        <a
          @mouseover="isHoveringPrintPdf = true"
          @mouseleave="isHoveringPrintPdf = false"
          :class="
            isHoveringPrintPdf ? 'link-color set-font' : 'underline set-font'
          "
          @click="openPDF(productId)"
          >Print PDF</a
        >
        &nbsp;
        <a
          @mouseover="isHoveringPrintAll = true"
          @mouseleave="isHoveringPrintAll = false"
          :class="
            isHoveringPrintAll ? 'link-color set-font' : 'underline set-font'
          "
          @click="printAll(productId)"
          >Print All</a
        >
        <v-row no-gutters class="table-border">
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="text set-font"
            style="
              font-size: 13px;
              font-weight: bold;
              background: #0055e3;
              color: #ffffff;
            "
          >
            {{ productDeatilByProductIds.product_headline }}
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <img
              ref="img"
              v-if="productUpperDetails.url"
              :id="productId"
              class="product-image"
              :src="
                !productUpperDetails.url
                  ? img.src
                  : productUpperDetails.url === 'No URL'
                  ? img.src
                  : productUpperDetails.url
              "
              alt="logo"
            />
            <v-skeleton-loader
              class="product-image"
              v-else
              type="card"
            ></v-skeleton-loader>
          </v-col>

          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            align-self="end"
          >
            <div
              v-if="
                productDeatilByProductIds.mChannelID === 5 ||
                productDeatilByProductIds.mChannelID === 9 ||
                productDeatilByProductIds.mChannelID === 10
              "
            >
              <span
                v-if="
                  productDeatilByProductIds.mChannelID === 5 &&
                  (imageType.is_flash || imageType.is_image || imageType.html)
                "
              >
                <span v-if="productUpperDetails.document_size_byte >= 0">
                  <span v-if="imageType.is_flash">
                    <div id="flashContent">
                      <a
                        href="http://www.adobe.com/go/getflashplayer"
                        target="_blank"
                        ><img
                          src="http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif"
                          alt="Get Adobe Flash player"
                          border="0"
                      /></a>
                    </div>
                  </span>
                  <span v-else>
                    <iframe :src="imageType.link" />
                    <br />
                    <a
                      @mouseover="isHovering = true"
                      @mouseleave="isHovering = false"
                      @click="openVideo(imageType.link)"
                      style="cursor: pointer; margin-left: -6px"
                      :class="isHovering ? 'set-font' : 'link-color set-font'"
                      >View in full screen
                    </a>
                  </span>
                  <!-- <span> </span> -->
                </span>
                <!-- {{ imageType }} SSSSs -->
              </span>
              <span
                v-if="
                  productDeatilByProductIds.mChannelID === 10 ||
                  productDeatilByProductIds.mChannelID === 9
                "
              >
                <a
                  @mouseover="isHovering = true"
                  @mouseleave="isHovering = false"
                  @click="openPDF(productId)"
                  style="cursor: pointer; margin-left: -6px"
                  :class="isHovering ? 'set-font' : 'link-color set-font'"
                  >View in full screen
                </a>
                <iframe
                  :src="`https://www.competiscan.com/productDocuments.php?id=${productId} `"
                ></iframe>
              </span>
            </div>
            <div v-else>
              <span>
                <div class="row">
                  <div class="column rw-col">
                    <a
                      @mouseover="isHovering = true"
                      @mouseleave="isHovering = false"
                      @click="openPDF(productId)"
                      style="cursor: pointer; margin-left: -6px"
                      :class="isHovering ? 'set-font' : 'link-color set-font'"
                      >View PDF Content
                    </a>
                    <span>
                      <v-img
                        @mouseover="isHovering = true"
                        @mouseleave="isHovering = false"
                        :width="20"
                        :height="17"
                        src="../../../assets/pdf.jpg"
                        class="pr-2"
                        @click="openPDF(productId)"
                      />
                    </span>
                    &nbsp;
                    <span v-if="productUpperDetails.size !== undefined">
                      [{{ productUpperDetails.size }}]
                    </span>
                    &nbsp;
                    <span v-if="isAnimation === true" class="rw-col">
                      <a
                        @mouseover="isHoveringHtml = true"
                        @mouseleave="isHoveringHtml = false"
                        @click="openHtmlTag(htmlPath, productId)"
                        :class="
                          isHoveringHtml ? 'set-font' : 'link-color set-font'
                        "
                        >Processed HTML
                      </a>
                      <v-img
                        :width="20"
                        :height="17"
                        class="pr-2"
                        @mouseover="isHoveringHtml = true"
                        @mouseleave="isHoveringHtml = false"
                        @click="openHtmlTag(htmlPath, productId)"
                        style="margin-right: 3px"
                        src="../../../assets/animation_condition.png"
                      />
                    </span>
                    &nbsp;
                    <span v-if="isWrench === true">
                      <v-img
                        :width="20"
                        :height="17"
                        class="pr-2"
                        style="margin-right: 3px"
                        @click="openAnalysis(mmuid)"
                        src="../../../assets/bar-graph.png"
                    /></span>
                    <a
                      v-if="showAiAnalysis"
                      @click="openAiAnalysis(productId)"
                      style="cursor: pointer"
                      class="hover-link"
                    >
                      <span>AI Analysis</span>
                    </a>
                    <span v-if="showAiAnalysis">
                      <v-img
                        :width="20"
                        :height="17"
                        src="../../../assets/product_analysis.png"
                        class="pr-2"
                        @click="openAiAnalysis(productId)"
                      />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </span>
            </div>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Entry ID: </strong>
            <span
              @mouseover="isHoveringEntryId = true"
              @mouseleave="isHoveringEntryId = false"
              @click="openEntryId"
              :class="
                !isHoveringEntryId && productDeatilByProductIds?.group
                  ? 'set-font link-color'
                  : 'set-font'
              "
              >&nbsp;{{ productDeatilByProductIds.entry_id }}</span
            >
            <div v-if="spendPopup" class="modal">
              <div class="spend_content">
                <div class="modal-header">
                  <a
                    href="#"
                    class="box-close set-font"
                    @click="spendPopup = false"
                    style="cursor: pointer"
                  >
                    close
                  </a>
                </div>

                <div class="modal-body">
                  <v-table
                    v-if="
                      productDeatilByProductIds.panelists_spend_impression !==
                        null &&
                      productDeatilByProductIds.panelists_spend_impression !==
                        undefined
                    "
                  >
                    <tbody>
                      <tr class="styling-rows-cols" height="10px">
                        <th colspan="2">
                          <strong
                            >Total Panelist Level Estimated Spend /
                            Impressions:</strong
                          >
                        </th>
                        <td colspan="1">
                          ${{ commafy(panalistDetails.total_spend) }} /
                          {{ commafy(panalistDetails.total_Impression) }}
                        </td>
                      </tr>
                      <tr class="styling-rows-cols">
                        <th colspan="3" style="height: 10px">
                          <br />
                          <br />
                          <strong>Estimated Spend / Impressions</strong>
                        </th>
                      </tr>
                      <tr class="styling-rows-cols" style="height: 35px">
                        <td align="center" style="font-size: 10px">
                          <strong>Panelist</strong>
                        </td>
                        <td align="center" style="font-size: 10px">
                          <strong>Spend</strong>
                        </td>
                        <td align="center" style="font-size: 10px">
                          <strong>Impressions</strong>
                        </td>
                      </tr>
                      <tr
                        v-for="(item, index) in panalistDetails.pan_detail"
                        :key="index"
                        height="10px"
                      >
                        <td align="center" style="font-size: 10px">
                          {{ item.compti_id }}
                        </td>
                        <td align="center" style="font-size: 10px">
                          {{ commafy(item.estimated_spend) }}
                        </td>
                        <td align="center" style="font-size: 10px">
                          {{ commafy(item.estimated_impressions) }}
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
          </v-col>

          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="panelistCompetiIds.length"
          >
            <span
              v-for="(item, index) in panelistCompetiIds"
              :key="`${item.compti_id}-${index}`"
            >
              <a
                @click="fetchAffinities(item.compti_id)"
                @mouseover="isHoveringCompetiID = true"
                @mouseleave="isHoveringCompetiID = false"
                :class="
                  isHoveringCompetiID
                    ? 'link-color-changes set-font'
                    : 'link-color set-font'
                "
                >{{ item.compti_id }}</a
              >{{ index < panelistCompetiIds.length - 1 ? ", " : "" }}
            </span>

            <div class="mt-1" v-if="panelistTotalRecords > panelistPageSize">
              <button
                class="set-font"
                @click="changePanelistPage(panelistPageNumber - 1)"
                :disabled="panelistPageNumber === 1 || isPanelistLoading"
              >
                Previous
              </button>
              <span class="set-font" style="margin: 0 8px">
                Page {{ panelistPageNumber }} of {{ panelistTotalPages }}
              </span>
              <button
                class="set-font"
                @click="changePanelistPage(panelistPageNumber + 1)"
                :disabled="
                  panelistPageNumber >= panelistTotalPages || isPanelistLoading
                "
              >
                Next
              </button>
            </div>

            <div v-if="competiIDPopup" class="modal">
              <div class="content-additonal">
                <div style="padding-top: 9%">
                  <div v-if="!loadingCompetiscanID">
                    <div
                      v-if="
                        affinitiesVal ||
                        loyaltyRetention ||
                        adderssChangeHistory
                      "
                    >
                      <div v-if="affinitiesVal">
                        <h1>Affinities:</h1>
                        <p>{{ affinitiesVal }}</p>
                      </div>
                      <hr />
                      <div v-if="loyaltyRetention">
                        <h1>Loyalty/Retention, Statement Companies :</h1>
                        <p>{{ loyaltyRetention }}</p>
                      </div>
                      <div v-if="adderssChangeHistory">
                        <h1>Address Change History :</h1>
                        <p>{{ adderssChangeHistory }}</p>
                      </div>
                    </div>
                    <div class="text-center" v-else>
                      <h1>No Data Found</h1>
                    </div>
                  </div>
                  <div class="text-center" v-else>
                    <v-progress-circular
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                  <a
                    @click="competiIDPopup = false"
                    class="box-close set-font"
                    style="cursor: pointer"
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </v-col>

          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="productDeatilByProductIds.external_link"
          >
            <a
              @mouseover="isHoveringExternalLink = true"
              @mouseleave="isHoveringExternalLink = false"
              :class="
                isHoveringExternalLink
                  ? 'link-color-changes set-font'
                  : 'link-color set-font'
              "
              :href="productDeatilByProductIds.external_link"
              target="_blank"
              >{{ productDeatilByProductIds.external_link }}</a
            >
          </v-col>

          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <!-- <strong>Estimated Mail Volume</strong> -->
            <div class="modal" v-if="emvAndevmPopup">
              <div class="content-email">
                <div class="modal-header">
                  <a
                    class="box-close set-font"
                    @click="emvAndevmPopup = false"
                    style="background-color: white; cursor: pointer"
                  >
                    close
                  </a>
                </div>

                <div class="content-email-body">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4">
                      <v-table>
                        <tbody>
                          <tr>
                            <td colspan="2">
                              <strong
                                class="set-emv-font"
                                style="font-size: 12px !important"
                                >Historical
                                {{
                                  penelistDetail.total_ppmv ? "EMV" : "EVE"
                                }}</strong
                              >
                            </td>
                          </tr>
                          <tr height="35">
                            <td>
                              <strong>
                                <span
                                  v-if="
                                    productDeatilByProductIds.mChannelID ===
                                      1 &&
                                    penelistDetail.total_ppmv !== 0 &&
                                    penelistDetail.total_ppmv !== undefined
                                  "
                                  class="set-emv-font"
                                >
                                  Estimated Mail Volume</span
                                >
                                <span
                                  v-if="
                                    productDeatilByProductIds.mChannelID ===
                                      3 &&
                                    penelistDetail.total_ppeve !== 0 &&
                                    penelistDetail.total_ppeve !== undefined
                                  "
                                  class="set-emv-font"
                                >
                                  Email Volume Estimates</span
                                >
                              </strong>
                            </td>
                            <td>
                              <span
                                v-if="
                                  productDeatilByProductIds.mChannelID === 1 &&
                                  penelistDetail.total_ppmv !== 0 &&
                                  penelistDetail.total_ppmv !== undefined
                                "
                                class="set-emv-font"
                              >
                                {{ commafy(penelistDetail.total_ppmv) }}
                              </span>
                              <span
                                v-if="
                                  productDeatilByProductIds.mChannelID === 3 &&
                                  penelistDetail.total_ppeve !== 0 &&
                                  penelistDetail.total_ppeve !== undefined
                                "
                                class="set-emv-font"
                              >
                                {{ commafy(penelistDetail.total_ppeve) }}</span
                              >
                            </td>
                          </tr>
                          <tr
                            v-for="(item, index) in penelistDetail.yearvise"
                            :key="index"
                          >
                            <td>
                              <strong class="set-emv-font">
                                {{ item.ppdate }}
                                {{ penelistDetail.total_ppmv ? "EMV" : "EVE" }}
                              </strong>
                            </td>
                            <td>
                              <span
                                v-if="item.total !== undefined"
                                class="set-emv-font"
                                >{{ commafy(item.total) }}</span
                              ><span v-else>{{ commafy(item.total) }}</span>
                            </td>
                          </tr>
                          <tr></tr>
                        </tbody>
                      </v-table>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-table>
                        <tbody>
                          <tr>
                            <td colspan="13">
                              <strong
                                class="set-emv-font"
                                style="font-size: 12px !important"
                              >
                                Mail Piece Observance
                              </strong>
                            </td>
                          </tr>
                          <tr height="35">
                            <td></td>
                            <td align="center">
                              <strong class="set-emv-font">JAN</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">FEB</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">MAR</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">APR</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">MAY</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">JUN</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">JUL</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">AUG</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">SEP</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">OCT</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">NOV</strong>
                            </td>
                            <td align="center">
                              <strong class="set-emv-font">DEC</strong>
                            </td>
                          </tr>
                          <tr
                            v-for="(item, index) in penelistDetail.yearvise"
                            :key="index"
                          >
                            <td align="center">
                              <strong class="set-emv-font">{{
                                item.ppdate
                              }}</strong>
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('01') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('01') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('02') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('02') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('03') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('03') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('04') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('04') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('05') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('05') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('06') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('06') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('07') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('07') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('08') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('08') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('09') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('09') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('10') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('10') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('11') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('11') !== -1
                                "
                                >X</span
                              >
                            </td>
                            <td
                              align="center"
                              :class="
                                item.month.split(',').indexOf('12') !== -1
                                  ? 'highlight-month'
                                  : ''
                              "
                            >
                              <span
                                v-if="
                                  item.month.split(',').indexOf('12') !== -1
                                "
                                >X</span
                              >
                            </td>
                          </tr>
                          <tr></tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>
                  <br />
                  <v-table>
                    <tbody>
                      <tr class="styling-rows-cols">
                        <td colspan="11">
                          <strong
                            class="set-emv-font"
                            style="font-size: 12px !important"
                            >Estimated Mail Volume Transparency</strong
                          >
                        </td>
                      </tr>
                      <tr>
                        <td align="center" width="20%">
                          <strong class="set-emv-font">Panelist</strong>
                        </td>
                        <td align="center">
                          <strong class="set-emv-font">Age</strong>
                        </td>
                        <td align="center">
                          <strong class="set-emv-font">Income</strong>
                        </td>
                        <td align="center">
                          <strong class="set-emv-font">State / Province</strong>
                        </td>
                        <td v-if="showFicoScore" align="center">
                          <strong class="set-emv-font">FicoScore</strong>
                        </td>
                        <td v-if="showCreditVision" align="center">
                          <strong class="set-emv-font">CreditVision</strong>
                        </td>
                        <td v-if="showVantageScore" align="center">
                          <strong class="set-emv-font">VantageScore</strong>
                        </td>
                        <td align="center">
                          <strong class="set-emv-font">ValueScore®</strong>
                        </td>
                        <td align="center">
                          <strong class="set-emv-font"
                            >ISO Risk Quality Index-Auto</strong
                          >
                        </td>
                        <td align="center">
                          <strong class="set-emv-font"
                            >ISO Risk Quality Index-Home</strong
                          >
                        </td>
                        <td align="center">
                          <strong class="set-emv-font"
                            >Estimated Mail Volume</strong
                          >
                        </td>
                      </tr>
                      <tr
                        v-for="(item, index) in penelistDetail.emvt"
                        :key="index"
                      >
                        <td align="center" width="20%">
                          <span class="set-emv-font">{{ item.compti_id }}</span>
                        </td>
                        <td align="center">
                          <span class="set-emv-font">{{ item.ppage }}</span>
                          <div
                            class="content-email-body-valuescore"
                            v-show="
                              valueScoreModal && highlightedIndex === index
                            "
                          >
                            {{ valueScoreVals.value }} -
                            {{ valueScoreVals.description }}
                            <a
                              class="box-close set-font"
                              @click="valueScoreModal = false"
                              style="cursor: pointer"
                            >
                              close
                            </a>
                          </div>
                        </td>
                        <td align="center">
                          <span class="set-emv-font">{{ item.pincome }}</span>
                        </td>
                        <td align="center">
                          <span class="set-emv-font"> {{ item.pstate }}</span>
                        </td>
                        <td v-if="showFicoScore" align="center">
                          <span class="set-emv-font">
                            {{
                              hasScoreValue(item.fico_score_range)
                                ? item.fico_score_range
                                : ""
                            }}
                          </span>
                        </td>
                        <td v-if="showCreditVision" align="center">
                          <span class="set-emv-font">
                            {{
                              hasScoreValue(item.creditvision_score_range)
                                ? item.creditvision_score_range
                                : ""
                            }}
                          </span>
                        </td>
                        <td v-if="showVantageScore" align="center">
                          <span class="set-emv-font">
                            {{
                              hasScoreValue(item.vantage_score_range)
                                ? item.vantage_score_range
                                : ""
                            }}
                          </span>
                        </td>

                        <td align="center">
                          <!-- Fix How to add another modal inside modal -->

                          <a
                            @mouseover="
                              headlineHover(
                                index,
                                item.valuseScore,
                                item.VSfH_description
                              )
                            "
                            @mouseleave="
                              headlineHover(
                                index,
                                item.valuseScore,
                                item.VSfH_description
                              )
                            "
                            ref="valuescore"
                            class="heading-css"
                            :class="
                              highlightedIndex === index
                                ? 'link-color-changes set-emv-font'
                                : 'link-color set-emv-font'
                            "
                          >
                            {{ item.valuseScore }}
                          </a>
                        </td>
                        <td align="center">
                          <a class="link-color set-emv-font">
                            {{ item.RAPA_ISO }}
                          </a>
                        </td>
                        <td align="center">
                          <a class="link-color set-emv-font">
                            {{ item.RAHO_ISO }}
                          </a>
                        </td>
                        <td align="center">
                          <span class="set-emv-font">
                            {{ commafy(item.estimated_mail_volume) }}
                          </span>
                        </td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
            <span
              v-if="productDeatilByProductIds.panelist_details !== undefined"
            >
              <strong
                v-if="
                  productDeatilByProductIds.mChannelID === 3 &&
                  penelistDetail.total_ppeve !== 0 &&
                  penelistDetail.total_ppeve !== undefined
                "
                >Email Volume Estimates:
              </strong>
              <strong
                v-if="
                  productDeatilByProductIds.mChannelID === 1 &&
                  penelistDetail.total_ppmv !== 0 &&
                  penelistDetail.total_ppmv !== undefined
                "
                >Estimated Mail Volume:
              </strong>
              <a
                @click="emvAndevmPopup = true"
                @mouseover="isPublication = true"
                @mouseleave="isPublication = false"
                v-if="
                  penelistDetail.total_ppeve !== 0 &&
                  penelistDetail.total_ppeve !== undefined
                "
                :class="
                  isPublication
                    ? 'link-color-changes set-font'
                    : 'link-color set-font'
                "
              >
                {{ commafy(penelistDetail.total_ppeve) }}
              </a>
              <a
                @click="emvAndevmPopup = true"
                @mouseover="isPublication = true"
                @mouseleave="isPublication = false"
                v-if="
                  penelistDetail.total_ppmv !== 0 &&
                  penelistDetail.total_ppmv !== undefined
                "
                :class="
                  isPublication
                    ? 'link-color-changes set-font'
                    : 'link-color set-font'
                "
              >
                {{ commafy(penelistDetail.total_ppmv) }}
              </a>
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.panelists_spend_impression !==
                undefined &&
              (productDeatilByProductIds.mChannelID === 5 ||
                productDeatilByProductIds.mChannelID === 9 ||
                productDeatilByProductIds.mChannelID === 10)
            "
          >
            <strong>Panelist Level Estimated: </strong>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.panelists_spend_impression !== undefined
            "
          >
            <a
              @click="spendPopup = true"
              @mouseover="isHoveringSpend = true"
              @mouseleave="isHoveringSpend = false"
              :class="
                isHoveringSpend
                  ? 'link-color-changes set-font'
                  : 'link-color set-font'
              "
              >Spend ($) / Impressions</a
            >
          </v-col>
          <!-- <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.estimate_spend !== undefined &&
              productDeatilByProductIds.estimate_spend !== null
            "
          >
            <strong>Total Estimated Spend / Impressions: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.estimate_spend }}
            </span>
          </v-col> -->
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.is_mobile !== undefined &&
              productDeatilByProductIds.is_mobile !== 0 &&
              productDeatilByProductIds.is_mobile !== null
            "
          >
            <strong>Digital Source: </strong>
            <span
              v-if="productDeatilByProductIds.is_mobile === 1"
              class="set-font"
              >Desktop</span
            >
            <span
              v-else-if="productDeatilByProductIds.is_mobile === 2"
              class="set-font"
              >Mobile</span
            >
          </v-col>

          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.simple_domain !== undefined &&
              productDeatilByProductIds.simple_domain !== null &&
              productDeatilByProductIds.mChannelID === 9
            "
          >
            <strong>Simple Domain: </strong>
            <span> {{ productDeatilByProductIds.simple_domain }} </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.sem_search_key !== undefined &&
              productDeatilByProductIds.sem_search_key !== null &&
              productDeatilByProductIds.mChannelID === 9
            "
          >
            <strong>SEM Search Key: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.sem_search_key }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.sem_url !== undefined &&
              productDeatilByProductIds.sem_url !== null &&
              productDeatilByProductIds.mChannelID === 9
            "
          >
            <strong>SEM Url: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.sem_url }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.sem_headline !== undefined &&
              productDeatilByProductIds.sem_headline !== null &&
              productDeatilByProductIds.mChannelID === 9
            "
          >
            <strong> SEM Headline: </strong>
            <spam class="set-font">
              {{ productDeatilByProductIds.sem_headline }}
            </spam>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.sem_description !== undefined &&
              productDeatilByProductIds.sem_description !== null &&
              productDeatilByProductIds.mChannelID === 9
            "
          >
            <strong> SEM Description: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.sem_description }}
            </span>
          </v-col>

          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Media Channel: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.mChannelName }}
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Audience: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.mPanelName }}
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Primary Company: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.primary_company }}
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Additional Companies: </strong>
            <span
              v-if="
                productDeatilByProductIds.Additional_companies !== undefined &&
                productDeatilByProductIds.Additional_companies.length > 0
              "
            >
              <span
                v-for="(
                  value, index
                ) in productDeatilByProductIds.Additional_companies"
                :key="index"
                class="item set-font"
              >
                {{ value }}
              </span>
            </span>
            <span v-else class="set-font">N/A</span>
          </v-col>

          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.stateName &&
              productDeatilByProductIds.mChannelID !== 6
            "
          >
            <strong>State/Province: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.stateName }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.edc_name !== undefined &&
              productDeatilByProductIds.edc_name !== null &&
              productDeatilByProductIds.mChannelID !== 6 &&
              catsSections.sector_id.includes(315)
            "
          >
            <strong>EDC / LDC / TDSP: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.edc_name }}
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Sector: </strong>
            <span
              v-for="val in catsSections.sector"
              :key="val"
              class="item set-font"
              >{{ val }}
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Category: </strong>
            <span
              v-for="(val, index) in catsSections.category"
              :key="index"
              class="item set-font"
            >
              {{ val }}
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <strong>Sub Category: </strong>
            <span v-if="catsSections.sub_category.length > 0">
              <span
                v-for="val in catsSections.sub_category"
                :key="val"
                class="item set-font"
              >
                {{ val }}
              </span>
            </span>
            <span v-else class="set-font">Not mentioned</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="subSubCategoryPresent"
          >
            <strong>Sub Sub Category: </strong>
            <span
              v-for="val in catsSections.sub_sub_category"
              :key="val"
              class="item set-font"
            >
              {{ val }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.worksite_voluntary !== undefined &&
              (catsSections.sector_id.includes(4) ||
                catsSections.sector_id.includes(5))
            "
          >
            <strong>Worksite/Voluntary: </strong>
            <span
              v-if="productDeatilByProductIds.worksite_voluntary === 0"
              class="set-font"
            >
              No
            </span>
            <span v-else class="set-font">Yes</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.Network_Name !== undefined &&
              productDeatilByProductIds.mChannelID === 6
            "
          >
            <strong>Network Name: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.Network_Name }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.No_of_tweets !== undefined &&
              productDeatilByProductIds.No_of_tweets > 0 &&
              productDeatilByProductIds.mChannelID === 6
            "
          >
            <strong v-if="productDeatilByProductIds.Network_Name === 'facebook'"
              >Number of Updates:
            </strong>
            <strong v-if="productDeatilByProductIds.Network_Name === 'twitter'"
              >Number of Tweets:
            </strong>
            <strong
              v-if="productDeatilByProductIds.Network_Name === 'instagram'"
              >Number of Posts:
            </strong>
            <strong v-if="productDeatilByProductIds.Network_Name === 'linkedin'"
              >Number of Posts:
            </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.No_of_tweets }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.No_of_fans !== undefined &&
              productDeatilByProductIds.mChannelID === 6
            "
          >
            <strong v-if="productDeatilByProductIds.Network_Name === 'facebook'"
              >Number of Fans:
            </strong>
            <strong v-else>Number of Followers: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.No_of_fans }}</span
            >
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.date_updated !== undefined &&
              productDeatilByProductIds.Network_Name !== undefined &&
              productDeatilByProductIds.mChannelID === 6
            "
          >
            <strong>Date Updated: </strong>
            <span class="set-font"
              >{{ productDeatilByProductIds.date_updated }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.media_adtype !== undefined &&
              productDeatilByProductIds.mChannelID === 6
            "
          >
            <strong>Social Media Ad Type: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.media_adtype
            }}</span>
          </v-col>

          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.affinity_association !== undefined &&
              productDeatilByProductIds.mChannelID !== 6
            "
          >
            <strong>Affinity/Association: </strong>
            <span
              v-if="productDeatilByProductIds.affinity_association === 'Yes'"
              class="set-font"
            >
              Yes
            </span>
            <span v-else class="set-font">No</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.affinityName !== undefined &&
              productDeatilByProductIds.affinityName !== null &&
              productDeatilByProductIds.mChannelID !== 6
            "
          >
            <strong>Affinity/Association Name: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.affinityName }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.AffinityCategoryName !== undefined &&
              productDeatilByProductIds.AffinityCategoryName !== null &&
              productDeatilByProductIds.mChannelID !== 6
            "
          >
            <strong>Affinity/Association Category Name: </strong>
            <span class="set-font">{{ affinityCategoryVal }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.document_content_type &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mChannelID === 5 ||
                productDeatilByProductIds.mChannelID === 7)
            "
          >
            <strong>Technology: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.document_content_type }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.document_placement &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mChannelID === 5 ||
                productDeatilByProductIds.mChannelID === 7)
            "
          >
            <strong>Size (pixel): </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.document_placement }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.traffic_site_count !== undefined &&
              productDeatilByProductIds.traffic_site_count !== null &&
              productDeatilByProductIds.traffic_sources !== undefined &&
              productDeatilByProductIds.traffic_sources !== null &&
              productDeatilByProductIds.traffic_sources !== ''
            "
          >
            <div v-if="trafficPopupBox" class="modal">
              <div class="content">
                <div class="modal-header" style="padding-bottom: 20px">
                  <a
                    @click="trafficPopupBox = false"
                    class="box-close set-font"
                    style="cursor: pointer"
                  >
                    close
                  </a>
                </div>
                <div class="modal-traffic-source-body">
                  <v-table>
                    <tbody>
                      <tr class="styling-rows-cols">
                        <td>
                          <strong class="set-emv-font">Traffic Sources</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="set-emv-font">{{
                            productDeatilByProductIds.traffic_sources
                          }}</span>
                        </td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
            <strong>View this record's</strong>
            <a
              @click="trafficPopupBox = true"
              @mouseover="isTraffic = true"
              @mouseleave="isTraffic = false"
              :class="isTraffic ? 'link-color-changes' : 'link-color'"
            >
              Traffic Sources
            </a>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.name !== undefined &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (catsSections.sector_id.includes(4) ||
                catsSections.sector_id.includes(5))
            "
          >
            <strong>Group Size: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.name !== null
                ? productDeatilByProductIds.name
                : "N/A"
            }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.oo_name !== undefined &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (catsSections.sector_id.includes(4) ||
                catsSections.sector_id.includes(5))
            "
          >
            <strong>Offer Origin: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.oo_name }}</span
            >
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.language !== undefined &&
              productDeatilByProductIds.mChannelID !== 6
            "
          >
            <strong>Campaign Language: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.language
            }}</span>
          </v-col>

          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="productDeatilByProductIds.print_details"
          >
            <div v-if="publicationPopupBox" class="modal">
              <div class="content">
                <div class="modal-header">
                  <a
                    @click="publicationPopupBox = false"
                    class="box-close set-font"
                    style="cursor: pointer"
                  >
                    close
                  </a>
                </div>

                <div class="modal-publication-body">
                  <v-table>
                    <tbody>
                      <tr class="styling-rows-cols">
                        <td class="publication-content-font-body">
                          <strong>Publication</strong>
                        </td>
                        <td class="publication-content-font-body">
                          <strong>Date</strong>
                        </td>
                      </tr>
                      <tr
                        v-for="(
                          item, index
                        ) in productDeatilByProductIds.print_details"
                        :key="index"
                      >
                        <td
                          class="styling-rows-cols publication-content-font-body"
                        >
                          {{ item.publicationName }}
                        </td>
                        <td
                          class="styling-rows-cols publication-content-font-body"
                        >
                          {{ item.publication_date }}
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
            <strong>This record has </strong>
            <a
              @click="publicationPopupBox = true"
              @mouseover="isPublication = true"
              @mouseleave="isPublication = false"
              :class="isPublication ? 'link-color-changes' : 'link-color'"
            >
              {{ productDeatilByProductIds.print_details.length }} Publication
            </a>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.print_details &&
              productDeatilByProductIds.mChannelID === 2 &&
              productDeatilByProductIds.mChannelID !== 6
            "
          >
            <strong>Publication Type: </strong>
            <span
              v-for="(value, index) in publicationTypeName"
              :key="index"
              class="item set-font"
            >
              {{ value }}
            </span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.age_pname !== undefined &&
              productDeatilByProductIds.age_pname !== null &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mpanel_id === 1 ||
                productDeatilByProductIds.mpanel_id === 2)
            "
          >
            <strong>Age: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.age_pname
            }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.incomeName !== undefined &&
              productDeatilByProductIds.incomeName !== null &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mpanel_id === 1 ||
                productDeatilByProductIds.mpanel_id === 2)
            "
          >
            <strong>Income: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.incomeName
            }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.mTypeName !== undefined &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mpanel_id === 1 ||
                productDeatilByProductIds.mpanel_id === 2)
            "
          >
            <strong>Mailing Type: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.mTypeName
            }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.fa_name !== undefined &&
              productDeatilByProductIds.fa_name !== null &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mpanel_id === 1 ||
                productDeatilByProductIds.mpanel_id === 2)
            "
          >
            <strong>Face Amount: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.fa_name
            }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.tl_name !== undefined &&
              productDeatilByProductIds.tl_name !== null &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mpanel_id === 1 ||
                productDeatilByProductIds.mpanel_id === 2)
            "
          >
            <strong>Term Length: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.tl_name
            }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.estimate_spend !== undefined &&
              productDeatilByProductIds.estimate_spend !== null &&
              productDeatilByProductIds.mChannelID !== 6 &&
              (productDeatilByProductIds.mpanel_id === 1 ||
                productDeatilByProductIds.mpanel_id === 2)
            "
          >
            <strong>Estimated Spend: </strong>
            <span class="set-font"
              >${{ commafy(productDeatilByProductIds.estimate_spend) }}</span
            >
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.delmethname !== undefined &&
              productDeatilByProductIds.mChannelID === 1 &&
              (productDeatilByProductIds.mpanel_id === 1 ||
                productDeatilByProductIds.mpanel_id === 2)
            "
          >
            <strong>Delivery Method: </strong>
            <span class="set-font">
              {{ productDeatilByProductIds.delmethname }}</span
            >
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.prescription !== undefined &&
              productDeatilByProductIds.prescription !== 0
            "
          >
            <strong>Rx: </strong>
            <span class="set-font">Yes</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.is_prescreen !== undefined &&
              productDeatilByProductIds.is_prescreen !== 0
            "
          >
            <strong>Pre-Screen &amp; Opt-Out Notice: </strong>
            <span class="set-font">Yes</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.fee_product !== undefined &&
              productDeatilByProductIds.fee_product !== 0
            "
          >
            <strong>Fee Product: </strong>
            <span class="set-font">Yes</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.ancillary_name !== undefined &&
              productDeatilByProductIds.ancillary_name !== null
            "
          >
            <strong>Ancillary Products: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.ancillary_name
            }}</span>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="6"
            lg="6"
            class="styling-rows-cols"
            v-if="
              productDeatilByProductIds.ridersName !== undefined &&
              productDeatilByProductIds.ridersName !== null
            "
          >
            <strong>Riders: </strong>
            <span class="set-font">{{
              productDeatilByProductIds.ridersName
            }}</span>
          </v-col>

          <v-col
            :cols="removeBorders.comm_type"
            :sm="removeBorders.comm_type"
            :md="removeBorders.comm_type"
            :lg="removeBorders.comm_type"
            class="styling-rows-cols"
            name="commtype"
          >
            <i>
              <strong>Communication Type: </strong>
              <span class="set-font">
                {{
                  productDeatilByProductIds.type === undefined ||
                  productDeatilByProductIds.type === null
                    ? " "
                    : productDeatilByProductIds.type
                }}
              </span>
            </i>
          </v-col>
          <v-col
            :cols="removeBorders.add_dtl"
            :sm="removeBorders.add_dtl"
            :md="removeBorders.add_dtl"
            :lg="removeBorders.add_dtl"
            class="styling-rows-cols"
            name="commtype1"
            v-if="
              productDeatilByProductIds.energy_details !== undefined ||
              productDeatilByProductIds.payment_cards !== undefined ||
              productDeatilByProductIds.mortgage_Loan_detail !== undefined ||
              productDeatilByProductIds.Telecom_detail !== undefined ||
              productDeatilByProductIds.TravelLeisure_details !== undefined ||
              productDeatilByProductIds.banking_details !== undefined ||
              productDeatilByProductIds.credit_cards_access !== undefined
            "
          >
            <div v-if="additionalPopup" class="modal">
              <div class="content-additonal">
                <div style="padding-top: 9%">
                  <div
                    v-if="
                      productDeatilByProductIds.energy_details !== undefined
                    "
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong> Energy - Term Details</strong>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.energy_details.ERateType !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong> Rate Type </strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          class="set-font"
                          v-if="
                            productDeatilByProductIds.energy_details
                              .ERateType !== 0
                          "
                        >
                          {{
                            productDeatilByProductIds.energy_details.ERateType
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.energy_details
                            .EOfferPrice !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Offer Price (per kWh)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.energy_details.EOfferPrice
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.energy_details
                            .ECancelFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Cancel Fee</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.energy_details
                              .ECancelFee == "Yes"
                              ? "Yes"
                              : "No"
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-if="productDeatilByProductIds.payment_cards !== undefined"
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong
                          >Payment Cards - Payment Card Offer Details</strong
                        >
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.payment_cards
                          .ApplicationType !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Application Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .ApplicationType
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CardNetwork !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Card Network</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.CardNetwork
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards.CardLevel !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Primary Card Level</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.CardLevel
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Rewards Program</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .RewardsProgram
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.payment_cards
                          .RewardsProgramEmphasis
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Rewards Program Emphasis</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .RewardsProgramEmphasis
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row
                      no-gutters
                      v-if="productDeatilByProductIds.payment_cards.RewardsRate"
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Reward Rate</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.RewardsRate
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong> Payment Cards - Regular Pricing</strong>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards &&
                          productDeatilByProductIds.payment_cards.LateFee !==
                            undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 1 Purchase Regular APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span v-if="productDeatilByProductIds.payment_cards">
                          {{
                            productDeatilByProductIds.payment_cards
                              .PurchaseRegularAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards &&
                          productDeatilByProductIds.payment_cards
                            .Tier2PurchaseRegularAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 2 Purchase Regular APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span v-if="productDeatilByProductIds.payment_cards">
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier2PurchaseRegularAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier3PurchaseRegularAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 3 Purchase Regular APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier3PurchaseRegularAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .PurchaseRateType !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Purchase Regular Rate Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.payment_cards
                              .PurchaseRateType !== undefined
                          "
                        >
                          {{
                            productDeatilByProductIds.payment_cards
                              .PurchaseRateType
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferRegularAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 1 Balance Transfer Regular APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferRegularAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier2BalanceTransferRegularAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 2 Balance Transfer Regular APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier2BalanceTransferRegularAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier3BalanceTransferRegularAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 3 Balance Transfer Regular APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier3BalanceTransferRegularAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferRateType !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Balance Transfer Regular Rate Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferRateType
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceRegularAPR !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceRegularAPR !== null
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 1 Cash Advance Regular APR (%)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceRegularAPR !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceRegularAPR !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.payment_cards
                                .CashAdvanceRegularAPR ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 2 Cash Advance Regular APR -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier2CashAdvanceRegularAPR !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .Tier2CashAdvanceRegularAPR !== null
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 2 Cash Advance Regular APR (%)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier2CashAdvanceRegularAPR !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .Tier2CashAdvanceRegularAPR !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.payment_cards
                                .Tier2CashAdvanceRegularAPR ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 3 Cash Advance Regular APR -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier3CashAdvanceRegularAPR !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .Tier3CashAdvanceRegularAPR !== null
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 3 Cash Advance Regular APR (%)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier3CashAdvanceRegularAPR !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .Tier3CashAdvanceRegularAPR !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.payment_cards
                                .Tier3CashAdvanceRegularAPR ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceRateType !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Cash Advance Regular Rate Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceRateType
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards.PenaltyAPR !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Penalty APR</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.PenaltyAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .PenaltyAPRDetails !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Penalty APR Details</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .PenaltyAPRDetails
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong> Payment Cards - Pricing: Fees & Limit</strong>
                      </v-col>
                    </v-row>
                    <!-- Tier 1 Annual Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards.AnnualFee !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 1 Annual Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier1AnnualFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 2 Annual Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier1AnnualFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 2 Annual Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier2AnnualFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 3 Annual Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier2AnnualFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 3 Annual Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.AnnualFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 1 Late Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 1 Late Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.Tier1LateFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 2 Late Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 2 Late Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.Tier2LateFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 3 Late Fee (from LateFee field) -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 3 Late Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{ productDeatilByProductIds.payment_cards.LateFee }}
                        </span>
                      </v-col>
                    </v-row>
                    <!-- Tier 1 Overlimit Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .OverlimitFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 1 Overlimit Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier1OverlimitFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 2 Overlimit Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier1OverlimitFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 2 Overlimit Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier2OverlimitFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- Tier 3 Overlimit Fee -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier2OverlimitFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Tier 3 Overlimit Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.OverlimitFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- BALANCE TRANSFER FEE SECTION -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferUsageFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Balance Transfer Usage Fee (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferUsageFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferMinimumFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Balance Transfer Minimum Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferMinimumFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferMaximumFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Balance Transfer Maximum Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferMaximumFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- CASH ADVANCE FEE SECTION -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceUsageFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Cash Advance Usage Fee (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceUsageFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceMinimumFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Cash Advance Minimum Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceMinimumFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceMaximumFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Cash Advance Maximum Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceMaximumFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- CARD LIMIT SECTION -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .MinimumCardLimit !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Minimum Card Limit ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .MinimumCardLimit
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .MonthlyMaintenanceFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Introductory Monthly Maintenance Fee ($)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .MonthlyMaintenanceFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <!-- MAINTENANCE FEES -->
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .StandardMonthlyMaintenanceFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Standard Monthly Maintenance Fee ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .StandardMonthlyMaintenanceFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .MaximumCardLimit !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Maximum Card Limit ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .MaximumCardLimit
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong> Payment Cards - Introductory Pricing</strong>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .PurchaseIntroductoryAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Purchase Introductory APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .PurchaseIntroductoryAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .PurchaseIntroductoryPeriod !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Purchase Introductory Period (Months)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .PurchaseIntroductoryPeriod
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Balance Transfer Introductory APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferIntroductoryAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryPeriod !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Balance Transfer Introductory Period (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferIntroductoryPeriod
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryUsageFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Tier 1 Balance Transfer Introductory Usage Fee
                          (%)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferIntroductoryUsageFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.payment_cards
                          .Tier2BalanceTransferIntroductoryUsageFee !==
                        undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Tier 2 Balance Transfer Introductory Usage Fee (%)
                        </strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .Tier2BalanceTransferIntroductoryUsageFee
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryMinimumFee !==
                            undefined &&
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryMinimumFee !== null
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>
                          Tier 1 Balance Transfer Introductory Minimum Fee ($)
                        </strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryMinimumFee !==
                            undefined &&
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryMinimumFee !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.payment_cards
                                .BalanceTransferIntroductoryMinimumFee ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier2BalanceTransferIntroductoryMinimumFee !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Tier 2 Balance Transfer Introductory Minimum Fee ($)
                        </strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .Tier2BalanceTransferIntroductoryMinimumFee
                        "
                      >
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards.Tier2BalanceTransferIntroductoryMinimumFee.toFixed(
                              2
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryMaximumFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Balance Transfer Introductory Maximum Fee ($)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferIntroductoryMaximumFee
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .BalanceTransferIntroductoryFeePeriod !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Balance Transfer Introductory Fee Period
                          (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .BalanceTransferIntroductoryFeePeriod
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Cash Advance Introductory APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceIntroductoryAPR
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryPeriod !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Cash Advance Introductory Period (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceIntroductoryPeriod
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryUsageFee !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryUsageFee !== null
                        "
                      >
                        <strong>Cash Advance Introductory Usage Fee (%)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryUsageFee !== undefined &&
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryUsageFee !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.payment_cards
                                .CashAdvanceIntroductoryUsageFee ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryMinimumFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Cash Advance Introductory Minimum Fee ($)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceIntroductoryMinimumFee
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryMaximumFee !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Cash Advance Introductory Maximum Fee ($)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceIntroductoryMaximumFee
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .CashAdvanceIntroductoryFeePeriod !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Cash Advance Introductory Fee Period (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .CashAdvanceIntroductoryFeePeriod
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong
                          >Payment Cards - Promotional Purchase Pricing</strong
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .PromotionalPurchasePricingUsageOfferPercent !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Promotional Purchase Pricing-Usage Offer (%)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .PromotionalPurchasePricingUsageOfferPercent
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.payment_cards
                            .PromotionalPurchasePricingUsageOfferMonth !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Promotional Purchase Pricing Term-Usage Offer
                          (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.payment_cards
                              .PromotionalPurchasePricingUsageOfferMonth
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-if="
                      productDeatilByProductIds.mortgage_Loan_detail !==
                      undefined
                    "
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong>
                          Mortgage & Loan - General Mortgage & Loan
                          Details</strong
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Refinance</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .refinance == "Yes"
                              ? "Yes"
                              : "No"
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail.fha !==
                            undefined ||
                          productDeatilByProductIds.mortgage_Loan_detail.fha !==
                            null
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>FHA</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.mortgage_Loan_detail
                              .fha !== undefined ||
                            productDeatilByProductIds.mortgage_Loan_detail
                              .fha !== null
                          "
                        >
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .fha === "Yes"
                              ? "Yes"
                              : "No"
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .MLApplicationType !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Application Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.mortgage_Loan_detail
                              .MLApplicationType !== 0
                          "
                        >
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .MLApplicationType
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong>
                          Mortgage & Loan - Regular Pricing Details</strong
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .OfferedLoanAmount !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Offered Loan Amount ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .OfferedLoanAmount
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .MaximumLoanAmount !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Maximum Loan Amount ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .MaximumLoanAmount
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .MinimumLoanAmount !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Minimum Loan Amount ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .MinimumLoanAmount
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .LoanTerm !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Loan Term (Months)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.mortgage_Loan_detail
                              .LoanTerm !== 0
                          "
                        >
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .LoanTerm
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .OfferedAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Offered APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .OfferedAPR
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .UpperAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Upper APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .UpperAPR
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .LowerAPR !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Lower APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .LowerAPR
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .RateType !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Rate Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.mortgage_Loan_detail
                              .RateType !== 0
                          "
                        >
                          {{
                            productDeatilByProductIds.mortgage_Loan_detail
                              .RateType
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong
                          >Mortgage & Loan - Introductory Pricing
                          Details</strong
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .IntroductoryAPR !== undefined
                        "
                      >
                        <strong>Introductory APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.mortgage_Loan_detail
                            .IntroductoryAPR
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.mortgage_Loan_detail
                            .IntroductoryPeriod !== undefined
                        "
                      >
                        <strong>Introductory Period (Months)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.mortgage_Loan_detail
                            .IntroductoryPeriod
                        }}</span>
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-if="
                      productDeatilByProductIds.Telecom_detail !== undefined
                    "
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong> Telecom - General Telecom Details</strong>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.Telecom_detail
                          .FeaturedPlan !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Plan Featured</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        {{
                          productDeatilByProductIds.Telecom_detail
                            .FeaturedPlan == "Yes"
                            ? "Yes"
                            : "No"
                        }}
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.Telecom_detail
                          .ContractRequired !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Contract Required</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        {{
                          productDeatilByProductIds.Telecom_detail
                            .ContractRequired === "Yes"
                            ? "Yes"
                            : "No"
                        }}
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.Telecom_detail
                          .internet_speed !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Internet Speed</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.Telecom_detail
                            .internet_speed
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12`"
                        class="styling-rows-cols"
                      >
                        <strong>Telecom - Pricing</strong>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.Telecom_detail.MonthlyCost !==
                        undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Monthly Cost ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.Telecom_detail.MonthlyCost
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.Telecom_detail
                            .LowerFeaturedMonthlyCost !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Lower Featured Monthly Cost ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.Telecom_detail
                            .LowerFeaturedMonthlyCost
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.Telecom_detail
                            .UpperFeaturedMonthlyCost !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Upper Featured Monthly Cost ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.Telecom_detail
                            .UpperFeaturedMonthlyCost
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.Telecom_detail
                            .ActivationCharge !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Activation Charge ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.Telecom_detail
                            .ActivationCharge
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong>Telecom - Introductory Pricing Details</strong>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.Telecom_detail
                            .TelecomIntroductoryCost !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Introductory Cost ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.Telecom_detail
                            .TelecomIntroductoryCost
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.Telecom_detail
                            .TelecomIntroductoryPeriod !== undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong>Introductory Period (Months)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.Telecom_detail
                            .TelecomIntroductoryPeriod
                        }}</span>
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-if="
                      productDeatilByProductIds.TravelLeisure_details !==
                      undefined
                    "
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong> Travel & Leisure - Credit/Debit</strong>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.TravelLeisure_details
                          .TLDebitCardMentioned !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong> Debit Card Mentioned</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        {{
                          productDeatilByProductIds.TravelLeisure_details
                            .TLDebitCardMentioned === 0
                            ? "No"
                            : "Yes"
                        }}
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.TravelLeisure_details
                          .TLCreditCardMentioned !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong> Credit Card Mentioned</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        {{
                          productDeatilByProductIds.TravelLeisure_details
                            .TLCreditCardMentioned === 0
                            ? "No"
                            : "Yes"
                        }}
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.TravelLeisure_details
                          .TLCardNetwork !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong> Card Network</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        {{
                          productDeatilByProductIds.TravelLeisure_details
                            .TLCardNetwork
                        }}
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-if="
                      productDeatilByProductIds.banking_details !== undefined
                    "
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong>Banking - General Banking Details</strong>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.banking_details
                          .MinimumDeposit !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Minimum Deposit ($)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.banking_details
                              .MinimumDeposit !== undefined
                          "
                          >{{
                            productDeatilByProductIds.banking_details
                              .MinimumDeposit
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong>Banking - Debit Card Details</strong>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.banking_details
                          .DebitCardMentioned !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Debit Card Mentioned</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.banking_details
                            .DebitCardMentioned === "Yes"
                            ? "Yes"
                            : "No"
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.banking_details
                          .BankingCardType !== undefined
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Card Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.banking_details
                            .BankingCardType
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong>Banking - Rewards Program Details</strong>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="
                        productDeatilByProductIds.banking_details
                          .BankingRewardsProgram
                      "
                    >
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Rewards Program</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <strong>{{
                          productDeatilByProductIds.banking_details
                            .BankingRewardsProgram === "Yes"
                            ? "Yes"
                            : "No"
                        }}</strong>
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-if="
                      productDeatilByProductIds.credit_cards_access !==
                        undefined &&
                      catsSections.category.includes('Credit Access Offer')
                    "
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong
                          >Credit Access Checks - Promotional Pricing
                          Details</strong
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong>Promotional Offer </strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.credit_cards_access
                            .PromotionalOffer == "Yes"
                            ? "Yes"
                            : "No"
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferIntroductoryAPRDetail_CAC !==
                          undefined
                        "
                      >
                        <strong
                          >Tier 1 Balance Transfer Introductory APR (%)</strong
                        >
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferIntroductoryAPRDetail_CAC !==
                          undefined
                        "
                      >
                        <span>{{
                          productDeatilByProductIds.credit_cards_access.BalanceTransferIntroductoryAPRDetail_CAC.toFixed(
                            2
                          )
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferIntroductoryPeriod_CAC1 !==
                          undefined
                        "
                      >
                        <strong
                          >Tier 1 Balance Transfer Introductory Period
                          (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferIntroductoryPeriod_CAC1
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferIntroductoryAPR_CAC2 !== undefined
                        "
                      >
                        <strong
                          >Tier 2 Balance Transfer Introductory APR (%)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .BalanceTransferIntroductoryAPR_CAC2 !== undefined
                          "
                          >{{
                            productDeatilByProductIds.credit_cards_access.BalanceTransferIntroductoryAPR_CAC2.toFixed(
                              2
                            )
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferIntroductoryPeriod_CAC2 !==
                          undefined
                        "
                      >
                        <strong
                          >Tier 2 Balance Transfer Introductory Period
                          (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferIntroductoryPeriod_CAC2
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PromotionalOfferUsageFee !== undefined
                        "
                      >
                        <strong
                          >Tier 1 Balance Transfer Introductory Usage Fee
                          (%)</strong
                        >
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PromotionalOfferUsageFee !== undefined
                        "
                      >
                        <span>{{
                          productDeatilByProductIds.credit_cards_access.PromotionalOfferUsageFee.toFixed(
                            2
                          )
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier2BalanceTransferIntroductoryUsageFee !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Tier 2 Balance Transfer Introductory Usage Fee (%)
                        </strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .Tier2BalanceTransferIntroductoryUsageFee !==
                            undefined
                          "
                        >
                          {{
                            productDeatilByProductIds.credit_cards_access.Tier2BalanceTransferIntroductoryUsageFee.toFixed(
                              2
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PromotionalOfferMinimumFee !== undefined
                        "
                      >
                        <strong
                          >Tier 1 Balance Transfer Introductory Minimum Fee
                          ($)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .PromotionalOfferMinimumFee !== undefined
                          "
                          >{{
                            productDeatilByProductIds.credit_cards_access.PromotionalOfferMinimumFee.toFixed(
                              2
                            )
                          }}</span
                        >
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier2BalanceTransferIntroductoryMinimumFee !==
                          undefined
                        "
                        style="padding-left: 11px !important"
                      >
                        <strong
                          >Tier 2 Balance Transfer Introductory Minimum Fee ($)
                        </strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .Tier2BalanceTransferIntroductoryMinimumFee !==
                            undefined
                          "
                        >
                          {{
                            productDeatilByProductIds.credit_cards_access.Tier2BalanceTransferIntroductoryMinimumFee.toFixed(
                              2
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier2CashAdvanceIntroductoryAPR_CAC !== undefined
                        "
                      >
                        <strong
                          >Tier 1 Cash Advance Introductory APR (%)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .Tier2CashAdvanceIntroductoryAPR_CAC !== undefined
                          "
                          >{{
                            productDeatilByProductIds.credit_cards_access.Tier2CashAdvanceIntroductoryAPR_CAC.toFixed(
                              2
                            )
                          }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceIntroductoryPeriod_CAC !== undefined
                        "
                      >
                        <strong
                          >Tier 1 Cash Advance Introductory Period
                          (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceIntroductoryPeriod_CAC
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier3CashAdvanceRegularAPR_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .Tier3CashAdvanceRegularAPR_CAC !== null
                        "
                      >
                        <strong>
                          Tier 2 Cash Advance Introductory APR (%)<!-- Fixed label here -->
                        </strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier3CashAdvanceRegularAPR_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .Tier3CashAdvanceRegularAPR_CAC !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.credit_cards_access
                                .Tier3CashAdvanceRegularAPR_CAC ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier2CashAdvanceIntroductoryAPRPeriod_CAC !==
                          undefined
                        "
                      >
                        <strong
                          >Tier 2 Cash Advance Introductory APR Period
                          (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.credit_cards_access
                              .Tier2CashAdvanceIntroductoryAPRPeriod_CAC
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceIntroductoryUsageFee_CAC !== undefined
                        "
                      >
                        <strong>Cash Advance Introductory Usage Fee (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .CashAdvanceIntroductoryUsageFee_CAC !== undefined
                          "
                        >
                          {{
                            productDeatilByProductIds.credit_cards_access.CashAdvanceIntroductoryUsageFee_CAC.toFixed(
                              2
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceIntroductoryMinimumFee_CAC !== undefined
                        "
                      >
                        <strong
                          >Cash Advance Introductory Minimum Fee ($)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.credit_cards_access
                              .CashAdvanceIntroductoryMinimumFee_CAC
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryAPR_CAC !== undefined
                        "
                      >
                        <strong>Tier 1 Purchase Introductory APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .PurchaseIntroductoryAPR_CAC !== undefined
                          "
                        >
                          {{
                            productDeatilByProductIds.credit_cards_access.PurchaseIntroductoryAPR_CAC.toFixed(
                              2
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryFeePeriod_CAC !== undefined
                        "
                      >
                        <strong
                          >Purchase Introductory Fee Period (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.credit_cards_access
                              .PurchaseIntroductoryFeePeriod_CAC
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier2PurchaseIntroductoryAPR_CAC !== undefined
                        "
                      >
                        <strong>Tier 2 Purchase Introductory APR (%)</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span
                          v-if="
                            productDeatilByProductIds.credit_cards_access
                              .Tier2PurchaseIntroductoryAPR_CAC !== undefined
                          "
                        >
                          {{
                            productDeatilByProductIds.credit_cards_access.Tier2PurchaseIntroductoryAPR_CAC.toFixed(
                              2
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .Tier2PurchaseIntroductoryPeriod_CAC !== undefined
                        "
                      >
                        <strong
                          >Tier 2 Purchase Introductory Period (Months)</strong
                        >
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.credit_cards_access
                              .Tier2PurchaseIntroductoryPeriod_CAC
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryUsageFee_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryUsageFee_CAC !== null
                        "
                      >
                        <strong>Purchase Introductory Usage Fee (%)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryUsageFee_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryUsageFee_CAC !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.credit_cards_access
                                .PurchaseIntroductoryUsageFee_CAC ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryMinimumFee_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryMinimumFee_CAC !== null
                        "
                      >
                        <strong>Purchase Introductory Minimum Fee ($)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryMinimumFee_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .PurchaseIntroductoryMinimumFee_CAC !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.credit_cards_access
                                .PurchaseIntroductoryMinimumFee_CAC ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong>Credit Access Checks - Regular Pricing</strong>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferRegularAPR_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferRegularAPR_CAC !== null
                        "
                      >
                        <strong>Balance Transfer Regular APR (%)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferRegularAPR_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferRegularAPR_CAC !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.credit_cards_access
                                .BalanceTransferRegularAPR_CAC ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .BalanceTransferRateType_CAC !== undefined
                        "
                      >
                        <strong>Balance Transfer Regular Rate Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.credit_cards_access
                              .BalanceTransferRateType_CAC
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceRegularAPR_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceRegularAPR_CAC !== null
                        "
                      >
                        <strong>Cash Advance Regular APR (%)</strong>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        class="styling-rows-cols"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceRegularAPR_CAC !== undefined &&
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceRegularAPR_CAC !== null
                        "
                      >
                        <span>
                          {{
                            (
                              productDeatilByProductIds.credit_cards_access
                                .CashAdvanceRegularAPR_CAC ?? 0
                            ).toFixed(2)
                          }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                        v-if="
                          productDeatilByProductIds.credit_cards_access
                            .CashAdvanceRegularAPR_CAC !== undefined
                        "
                      >
                        <strong>Cash Advance Regular Rate Type</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>
                          {{
                            productDeatilByProductIds.credit_cards_access
                              .CashAdvanceRateType_CAC
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-if="productDeatilByProductIds.retail_detail !== undefined"
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        class="styling-rows-cols"
                      >
                        <strong> Retail - Credit</strong>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="10"
                        sm="10"
                        md="10"
                        class="styling-rows-cols"
                        style="padding-left: 11px !important"
                      >
                        <strong> Credit Card Mentioned</strong>
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="styling-rows-cols">
                        <span>{{
                          productDeatilByProductIds.retail_detail
                            .RCreditCardMentioned === 0
                            ? "No"
                            : "Yes"
                        }}</span>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <a
                  @click="additionalPopup = false"
                  class="box-close set-font"
                  style="cursor: pointer"
                >
                  close
                </a>
              </div>
            </div>
            <a
              @click="additionalPopup = true"
              @mouseover="isHoveringAdd = true"
              @mouseleave="isHoveringAdd = false"
              :class="
                isHoveringAdd
                  ? 'link-color-changes set-font'
                  : 'link-color set-font'
              "
              >Additional Details</a
            >
          </v-col>

          <div style="width: 100%"></div>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <span
              @mouseover="isHoveringSendLink = true"
              @mouseleave="isHoveringSendLink = false"
              :class="isHoveringSendLink ? 'set-font' : 'link-color set-font'"
              @click="openV1Links(1)"
              >Send this as a link to your colleague</span
            >
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <span v-if="false">
              <span
                @mouseover="isHoveringProductContent = true"
                @mouseleave="isHoveringProductContent = false"
                @click="openPdfContentFunction"
                :class="
                  isHoveringProductContent ? 'set-font' : 'link-color set-font'
                "
                >Download Creative Execution</span
              >
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <span
              @mouseover="isHoveringQAlink = true"
              @mouseleave="isHoveringQAlink = false"
              @click="openV1Links(2)"
              :class="isHoveringQAlink ? 'set-font' : 'link-color set-font'"
              style="font-style: italic"
              >Send this as a QA link to your colleague</span
            >
            <br />
            <input
              type="checkbox"
              id="vehicle1"
              name="vehicle1"
              value="Bike"
              label=""
              v-model="isQaCerified"
              :checked="isQaCerified"
            />
            <i class="set-font"> QA Certified </i>
          </v-col>
          <v-col cols="6" sm="6" md="6" lg="6" class="styling-rows-cols">
            <span v-if="dtsVal">
              <span
                @mouseover="isHoveringProductContent = true"
                @mouseleave="isHoveringProductContent = false"
                @click="openPdfContentFunction"
                :class="
                  isHoveringProductContent ? 'set-font' : 'link-color set-font'
                "
                style="font-style: italic"
                >View Product Content in text format</span
              >
            </span>
          </v-col>
        </v-row>

        <a
          @mouseover="isCloseWindow = true"
          @mouseleave="isCloseWindow = false"
          :class="isCloseWindow ? 'link-color set-font' : 'underline set-font'"
          @click="closeWindow"
          >Close-Window</a
        >
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
/*eslint-disable*/
import {
  ref,
  computed,
  onBeforeMount,
  watchEffect,
  watch,
  onMounted,
  onBeforeUpdate,
  onActivated,
  nextTick,
  onBeforeUnmount,
  inject,
} from "vue";
import config from "@/config"; 
import Loading from "vue-loading-overlay";
import logo from "../../../assets/logo.png";
import notfoundImage from "../../../assets/imageNotFound.gif";
import VueCookies from "vue-cookies";

export default {
  components: {
    Loading,
  },
  setup() {
    const affinityCategoryVal = ref("");
    const loadingCompetiscanID = ref(false);
    const dtsVal = ref("");
    const affinitiesVal = ref("");
    const loyaltyRetention = ref("");
    const adderssChangeHistory = ref("");
    const isLoading = ref(false);
    const competiIDPopup = ref(false);
    const productBasicDeatails = ref({});
    const productUpperDetails = ref({});
    const productId = ref(null);
    const productDeatilByProductIds = ref({});
    // Show AI Analysis icon only when the user has permission for it.
    // API returns ai_analysis_link as "No" (no permission / not available)
    // or a truthy value/link (e.g. "Yes") when the user has access.
    const showAiAnalysis = computed(() => {
      const aiAnalysisLink = productDeatilByProductIds.value?.ai_analysis_link;
      return !!aiAnalysisLink && aiAnalysisLink !== "No";
    });
    const productDeatilByProductIdsRes = ref([]);
    const isHovering = ref(false);
    const isHoveringEntryId = ref(false);
    const isHoveringPrintDetails = ref(false);
    const isHoveringPrintAll = ref(false);
    const isHoveringPrintPdf = ref(false);
    const isHoveringHtml = ref(false);
    const isHoveringSendLink = ref(false);
    const isHoveringAdd = ref(false);
    const isHoveringCompetiID = ref(false);
    const isHoveringExternalLink = ref(false);
    const isHoveringProductContent = ref(false);
    const isHoveringQAlink = ref(false);
    const openPdfContent = ref(null);
    const isQaCerified = ref(false);
    const isPublication = ref(false);
    const htmlPath = ref("https://www.competiscan.com/processed-html.php?id=");
    const subSubCategoryPresent = ref(false);
    const isCloseWindow = ref(false);
    const isHoveringSpend = ref(false);
    const isTraffic = ref(false);
    const panalistDetails = ref({});
    const http = ref(inject("http"));

    // Email tracking API
    const trackingId = ref(null);
    const productViews = ref({});
    const valueScoreVals = ref({});
    const valueScoreModal = ref(false);
    const highlightedIndex = ref(null);
    const isAnimation = ref(false);
    const isWrench = ref(false);
    const emvAndevmPopup = ref(false);
    const publicationPopupBox = ref(false);
    const trafficPopupBox = ref(false);
    const spendPopup = ref(false);
    const additionalPopup = ref(false);
    const mmuid = ref(null);
    const valuescore = ref(null);
    const publicationTypeName = ref([]);
    const removeBorders = ref({
      comm_type: 6,
      add_dtl: 6,
    });

    const imageType = ref({
      is_flash: false,
      is_image: false,
      document_id: 0,
      link: "",
    });
    const catsSections = ref({
      sector: [],
      category: [],
      sub_category: [],
      sub_sub_category: [],
      sector_id: [],
    });
    const penelistDetail = ref({});
    const panelistCompetiIds = ref([]);
    const panelistPageNumber = ref(1);
    const panelistPageSize = ref(10);
    const panelistTotalRecords = ref(0);
    const panelistTotalPages = ref(1);
    const isPanelistLoading = ref(false);

    // Score columns are shown only when the current user's API response contains values.
    const showFicoScore = ref(false);
    const showCreditVision = ref(false);
    const showVantageScore = ref(false);
    // const store = useStore();
    const img = ref(new Image());

    onBeforeMount(async () => {
      isLoading.value = true;
      img.value.onload = function (val) {
        img.value.height = val.height;
        img.value.width = val.width;
      };

      img.value.src = notfoundImage;
      const urlParams = new URLSearchParams(window.location.search);
      productId.value = await urlParams.get("id");

      // Email tracking: read trmsg from Product Detail URL.
      const trmsg = urlParams.get("trmsg");
      console.log("trmsg from URL:", trmsg);

      if (trmsg) {
        await updateEmailTracking(trmsg);
      }


      // Fetch dts_val from the new dtsvalues API
      fetch(`${http.value.dtsvalues}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ product_id: productId.value }),
      })
        .then((res) => res.json())
        .then((data) => {
          dtsVal.value = data.dts_val || "";
        })
        .catch((e) => console.error("dtsvalues fetch failed", e));

      // if (window.product_deatail_defaults !== undefined) {
      //   localStorage.setItem(
      //     "productBasicDeatails",
      //     JSON.stringify(window.product_deatail_defaults)
      //   );
      // }
      // productBasicDeatails.value = JSON.parse(
      //   localStorage.getItem("productBasicDeatails")
      // );
      if (VueCookies.get("competiscaner")) {
        if (productDeatilByProductIds.value.mChannelID === 5) {
          imageType.value.document_id = 2;
        } else {
          imageType.value.document_id = 1;
        }

        const mpanel_id_inc = [1, 2];
        const apidata = {
          product_id: productId.value,
        };

        VueCookies.set("lastURL", null, null, null, ".competiscan.com");
        imageType.value.link = `https://www.competiscan.com/productDocuments.php?id=${productId.value}&did=${imageType.value.document_id}`;
        const userId = VueCookies.get("competiscaner")?.split(':')?.[3];
        fetch(`${http.value.productdata}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userID: userId
          },
          body: JSON.stringify(apidata),
        }).then((response) => {
          response.json().then(async (data) => {
            productDeatilByProductIds.value = await data;

            if (productDeatilByProductIds.value.print_details) {
              publicationTypeName.value = getPrintDetailName(
                productDeatilByProductIds.value.print_details
              );
            }

            if (productDeatilByProductIds.value.AffinityCategoryName) {
              affinityCategoryVal.value = getAffinityCategory(
                productDeatilByProductIds.value.AffinityCategoryName
              );
            }
            if (data !== null) {
              if (productDeatilByProductIds.value.is_qa !== undefined) {
                if (productDeatilByProductIds.value.is_qa === 0) {
                  isQaCerified.value = false;
                } else {
                  isQaCerified.value = true;
                }
              }
              const d1 = Date.parse(data.approved_date);
              const d2 = Date.parse("2020-12-01 00:00:00");
              if (
                data.mChannelID === 3 &&
                mpanel_id_inc.includes(data.mpanel_id) &&
                data.electronic_id === 1 &&
                d1 >= d2
              ) {
                isAnimation.value = true;
              } else {
                isAnimation.value = false;
              }
              await getImageAndSize();
              await getMuid();
              if (
                productDeatilByProductIds.value.panelist_details !==
                undefined &&
                productDeatilByProductIds.value.panelist_details !== null
              ) {
                filterPenelistDetail(
                  productDeatilByProductIds.value.panelist_details
                );
                updateScoreColumnVisibility(
                  productDeatilByProductIds.value.panelist_details
                );
              }

              await fetchPanelistDetails();
              if (
                productDeatilByProductIds.value.panelists_spend_impression !==
                undefined &&
                productDeatilByProductIds.value.panelists_spend_impression !==
                null
              ) {
                filterSpend(
                  productDeatilByProductIds.value.panelists_spend_impression
                );
              }

              getImageVideoPdf();
              if (
                productDeatilByProductIds.value.Sector_detail !== undefined &&
                productDeatilByProductIds.value.Sector_detail !== null
              ) {
                for (
                  let i = 0;
                  i < productDeatilByProductIds.value.Sector_detail.length;
                  i++
                ) {
                  if (
                    productDeatilByProductIds.value.Sector_detail[i]
                      .sub_category
                  ) {
                    if (
                      !catsSections.value.sub_category.includes(
                        productDeatilByProductIds.value.Sector_detail[
                          i
                        ].sub_category.trim()
                      )
                    )
                      catsSections.value.sub_category.push(
                        productDeatilByProductIds.value.Sector_detail[i]
                          .sub_category
                      );
                  }
                  if (productDeatilByProductIds.value.Sector_detail[i].sector) {
                    if (
                      !catsSections.value.sector.includes(
                        productDeatilByProductIds.value.Sector_detail[
                          i
                        ].sector.trim()
                      )
                    )
                      catsSections.value.sector.push(
                        productDeatilByProductIds.value.Sector_detail[i].sector
                      );
                  }
                  if (
                    productDeatilByProductIds.value.Sector_detail[i].category
                  ) {
                    if (
                      !catsSections.value.category.includes(
                        productDeatilByProductIds.value.Sector_detail[
                          i
                        ].category.trim()
                      )
                    )
                      catsSections.value.category.push(
                        productDeatilByProductIds.value.Sector_detail[i]
                          .category
                      );
                  }
                  if (
                    productDeatilByProductIds.value.Sector_detail[i]
                      .sub_sub_category
                  ) {
                    catsSections.value.sub_sub_category.push(
                      productDeatilByProductIds.value.Sector_detail[i]
                        .sub_sub_category
                    );
                  }
                  if (
                    productDeatilByProductIds.value.Sector_detail[i].sector_id
                  ) {
                    catsSections.value.sector_id.push(
                      productDeatilByProductIds.value.Sector_detail[i].sector_id
                    );
                  }
                }
                if (catsSections.value.sub_sub_category.length > 0) {
                  subSubCategoryPresent.value = true;
                } else {
                  subSubCategoryPresent.value = false;
                }
              }
            }
            setTimeout(() => {
              remBor();
            }, 1);
            isLoading.value = false;
          });
        });
      }
    });
    async function getImageVideoPdf() {
      const apiUrl =
        await `${http.value.product}imagelist?product_type=ProductImg&product_id=${productId.value}`;
      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            response.json().then((data) => {
              if (data !== undefined) {
                productViews.value = data.payload[0];
              }
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }

    function videoSrc() {
      return productViews.value.downlaod_url;
    }
    function openInternalModal() {
      var modal = document.getElementById("valusescore-popup-box");
      modal.style.display = "block";
    }
    function filterSpend(e) {
      let vals = [];
      for (let i = 0; i < e.length; i++) {
        if (i !== e.length - 1 && i !== e.length - 2) {
          vals.push(e[i]);
          Object.assign(panalistDetails.value, {
            pan_detail: vals,
          });
        }
        if (i === e.length - 1) {
          Object.assign(panalistDetails.value, {
            total_spend: e[i].total_spend,
          });
        }
        if (i === e.length - 2) {
          Object.assign(panalistDetails.value, {
            total_Impression: e[i].total_Impression,
          });
        }
      }
    }

    function hasScoreValue(value) {
      if (value === null || value === undefined) {
        return false;
      }

      if (typeof value === "string") {
        const normalized = value.trim();
        return normalized !== "" && normalized !== "0";
      }

      return Number(value) > 0;
    }

    function updateScoreColumnVisibility(rows) {
      const panelistRows = Array.isArray(rows) ? rows : [];

      showFicoScore.value = panelistRows.some((item) =>
        hasScoreValue(item?.fico_score_range)
      );

      // Show the CreditVision column whenever the backend sends the
      // creditvision_score_range field, including when its value is an
      // empty string (""). Hide it only when the field is missing or null.
      showCreditVision.value = panelistRows.some(
        (item) =>
          item?.creditvision_score_range !== undefined &&
          item?.creditvision_score_range !== null
      );

      showVantageScore.value = panelistRows.some((item) =>
        hasScoreValue(item?.vantage_score_range)
      );
    }

    function normalizePanelistResponse(response) {
      const rows =
        response?.data?.pan_detail ||
        response?.data?.panelist_details ||
        response?.data?.records ||
        response?.payload?.pan_detail ||
        response?.payload?.panelist_details ||
        response?.payload?.records ||
        response?.pan_detail ||
        response?.panelist_details ||
        response?.records ||
        response?.data ||
        response?.payload ||
        [];

      const mChannelID =
        response?.mChannelID ||
        response?.data?.mChannelID ||
        response?.payload?.mChannelID ||
        productDeatilByProductIds.value?.mChannelID;

      const total =
        response?.total_records ||
        response?.data?.total_records ||
        response?.payload?.total_records ||
        response?.total ||
        response?.data?.total ||
        response?.payload?.total ||
        rows.length;

      const mappedRows = Array.isArray(rows)
        ? rows.map((item) => {
            if (!item || !item.panelist_id) {
              return item;
            }

            return {
              ...item,
              estimated_mail_volume:
                Number(mChannelID) === 3 ? item.ppeve : item.ppmv,
            };
          })
        : [];

      return {
        rows: mappedRows,
        total: Number(total) || 0,
        mChannelID: mChannelID ? Number(mChannelID) : null,
      };
    }

    async function updateEmailTracking(trmsg) {
      if (!trmsg) {
        console.log("trmsg is missing");
        return null;
      }

      try {
        let decodedTrackingId = String(trmsg).trim();

        // Same behavior as the old PHP code:
        // numeric value = use directly; otherwise decode Base64 3 times.
        if (!/^\d+$/.test(decodedTrackingId)) {
          decodedTrackingId = atob(decodedTrackingId);
          decodedTrackingId = atob(decodedTrackingId);
          decodedTrackingId = atob(decodedTrackingId);
        }

        if (!/^\d+$/.test(decodedTrackingId)) {
          console.error("Invalid trmsg after decoding:", decodedTrackingId);
          return null;
        }

        trackingId.value = Number(decodedTrackingId);

        const response = await fetch(http.value.trackingid, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tracking_id: trackingId.value,
          }),
        });

        if (!response.ok) {
          throw new Error(
            `Tracking API failed: ${response.status} ${response.statusText}`
          );
        }

        const result = await response.json();
        console.log("Tracking API response:", result);

        return result;
      } catch (error) {
        console.error("Email tracking failed:", error);
        return null;
      }
    }

    async function fetchPanelistDetails(pageNumber = panelistPageNumber.value) {
      if (!productId.value) return;

      isPanelistLoading.value = true;

      try {
        const apiUrl = `${http.value.panelistdetails}`;
        const userId = VueCookies.get("competiscaner")?.split(":")?.[3];
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userID: userId,
          },
          body: JSON.stringify({
            product_id: Number(productId.value),
            page_number: Number(pageNumber),
            page_size: Number(panelistPageSize.value),
          }),
        });

        if (!response.ok) {
          throw new Error(`Panelist details API failed: ${response.status}`);
        }

        const result = await response.json();
        const { rows, total, mChannelID } = normalizePanelistResponse(result);

        if (mChannelID) {
          productDeatilByProductIds.value.mChannelID = mChannelID;
        }

        productDeatilByProductIds.value.panelist_details = rows;
        filterPenelistDetail(rows);
        updateScoreColumnVisibility(rows);

        panelistCompetiIds.value = rows.filter((item) => item?.compti_id);
        panelistTotalRecords.value = total || panelistCompetiIds.value.length;
        panelistTotalPages.value = Math.max(
          1,
          Math.ceil(panelistTotalRecords.value / panelistPageSize.value)
        );
        panelistPageNumber.value = Number(pageNumber);
      } catch (error) {
        console.error("Panelist details fetch failed", error);
        panelistCompetiIds.value = penelistDetail.value?.compti_id
          ? [{ compti_id: penelistDetail.value.compti_id }]
          : [];
        panelistTotalRecords.value = panelistCompetiIds.value.length;
        panelistTotalPages.value = 1;
      } finally {
        isPanelistLoading.value = false;
      }
    }

    function changePanelistPage(pageNumber) {
      if (
        pageNumber < 1 ||
        pageNumber > panelistTotalPages.value ||
        pageNumber === panelistPageNumber.value
      ) {
        return;
      }

      fetchPanelistDetails(pageNumber);
    }

    function filterPenelistDetail(e) {
      let ppagelocal = [];
      let year = [];

      penelistDetail.value = {};

      if (!Array.isArray(e)) {
        return;
      }

      for (let i = 0; i < e.length; i++) {
        if (e[i].total_ppmv !== undefined) {
          Object.assign(penelistDetail.value, {
            total_ppmv: e[i].total_ppmv,
          });
        }
        if (e[i].compti_id !== undefined) {
          Object.assign(penelistDetail.value, {
            compti_id: e[i].compti_id,
          });
        }
        if (e[i].total_ppeve !== undefined) {
          Object.assign(penelistDetail.value, {
            total_ppeve: e[i].total_ppeve,
          });
        }
        if (e[i].panelist_id !== undefined) {
          ppagelocal.push(e[i]);
          year.push({
            ppdate: e[i].ppdate,
            amt:
              e[i].estimated_mail_volume !== undefined
                ? e[i].estimated_mail_volume
                : e[i].ppeve !== undefined
                ? e[i].ppeve
                : e[i].ppmv,
          });

          Object.assign(penelistDetail.value, {
            emvt: ppagelocal,
          });
        }
      }

      const reducer = (a, c) => {
        if (!c.ppdate) {
          return a;
        }

        const item = a.find(
          (x) => x.ppdate.substring(0, 4) === c.ppdate.substring(0, 4)
        );
        if (item) {
          item.total += Number(c.amt) || 0;
          item.month += c.ppdate.substring(5, 7) + ",";
        } else {
          const newItem = {
            ppdate: c.ppdate.substring(0, 4),
            total: Number(c.amt) || 0,
            month: c.ppdate.substring(5, 7) + ",",
          };
          a.push(newItem);
        }
        return a;
      };
      Object.assign(penelistDetail.value, {
        yearvise: year.reduce(reducer, []),
      });
    }

    function remBor() {
      nextTick(() => {
        let cmm = document.getElementsByName("commtype");
        let cmm1 = document.getElementsByName("commtype1");
        // var rect = cmm.getBoundingClientRect();
        if (
          cmm[0] !== undefined &&
          cmm[0].offsetLeft < 30 &&
          cmm[0].nextElementSibling.classList.length === 0
        ) {
          removeBorders.value.comm_type = 12;
          // cmm[0].previousElementSibling.classList.remove("styling-rows-cols");
        }
        if (
          cmm1[0] !== undefined &&
          cmm1[0].offsetLeft < 30 &&
          cmm1[0].nextElementSibling.classList.length === 0
        ) {
          removeBorders.value.add_dtl = 12;
        }
      });
    }

    function openPDF(pid) {
      window.open(
        `https://www.competiscan.com/productDocuments.php?id=${pid} `,
        "_blank",
        "width=700,height=800"
      );
    }
    function openAiAnalysis(pid) {
      window.open(
        `https://ai-analysis.competiscan.com/?productid=${pid} `,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,width=" +
        screen.availWidth +
        ",height=" +
        screen.availHeight
      );
    }
    function printAll(pid) {
      window.open(
        `https://www.competiscan.com/productDetail.php?id=${pid}&did=1&makepdf=1 `,
        "_blank",
        "width=700,height=800"
      );
    }

    function openEntryId() {
      if(!productDeatilByProductIds.value?.group){
        return
      }
      let ec_content_type = "email";
      if (productDeatilByProductIds.value.mChannelID === 1) {
        ec_content_type = "direct";
      }
      if (productDeatilByProductIds.value.mChannelID === 2) {
        ec_content_type = "print_media";
      }
      if (productDeatilByProductIds.value.mChannelID === 6) {
        ec_content_type = "social_media";
      }
      if (productDeatilByProductIds.value.mChannelID === 14) {
        ec_content_type = "website_url";
      }
      if (productDeatilByProductIds.value.mChannelID === 5) {
        ec_content_type = "mobiledigital&product_status=1";
      }
      if (
        productDeatilByProductIds.value.mChannelID === "Search Engine Marketing"
      ) {
        ec_content_type = "mobiledigital&product_status=1";
      }
      if (productDeatilByProductIds.value.mChannelID === 10) {
        ec_content_type = "mobiledigital&product_status=1";
      }
      if (productDeatilByProductIds.value.mChannelID === 3) {
        ec_content_type = "email";
      }
      window.open(
        `https://cs.competiscan.com/addproduct/v2/${productId.value}?ec_content_type=${ec_content_type} `,
        "_blank"
      );
    }

    function closeWindow() {
      window.close();
    }

    function openHtmlTag(url, id) {
      window.open(url + id, "popup", "width=800,height=800");
    }

    function openPdfContentFunction() {
      // showProduct.value = true;
      const path = window.location.href
        .replace(window.location.pathname, "")
        .replace(window.location.search, "");
      // let newTab = null;
      if (openPdfContent.value === null) {
        openPdfContent.value = window.open(
          `${path}/pdfcontentdetail?id=${productId.value}`,
          "_blank",
          "width=1368,height=664,top=10"
        );
        // openPdfContent.value.product_deatail_defaults = e;
      } else {
        openPdfContent.value.focus();
      }
      openPdfContent.value.onunload = function () {
        if (
          openPdfContent.value !== null &&
          openPdfContent.value.document.location.href !== "about:blank"
        ) {
          openPdfContent.value = null;
        }
      };
    }

    function openVideo(e) {
      window.open(e, "_blank", "width=1368,height=664,top=10");
    }

    function openAnalysis(muid) {
      window.open(
        `https://vat.competiscan.com/getanalysis/${muid}`,
        "_blank",
        "width=1368,height=664,top=10"
      );
    }

    function openV1Links(e) {
      if (e === 1) {
        window.open(
          `https://www.competiscan.com/sendLink.php?id=${productId.value}&send_mode=1`,
          "_blank",
          "width=1368,height=664,top=10"
        );
      }
      if (e === 2) {
        window.open(
          `https://www.competiscan.com/sendLink.php?id=${productId.value}&send_mode=2`,
          "_blank",
          "width=1368,height=664,top=10"
        );
      }
    }
    function headlineHover(id, value, description) {
      highlightedIndex.value = id;
      Object.assign(valueScoreVals.value, {
        value: value,
        description: description,
      });
      valueScoreModal.value = true;
    }
    function getImageAndSize() {
      // loader.value = false;
      const apiUrl = `${http.value.filesize}`;
      // const apiUrl = "https://dev02.competiscan.com:5012/filesize";

      // Fetch data from the API
      const ids = [];
      ids.push(Number(productId.value));
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ product_ids: ids }),
      })
        .then((response) => {
          response.json().then(async (data) => {
            if (data.length > 0) {
              await Object.assign(productUpperDetails.value, {
                document_content_type: data[0].document_content_type,
                document_size_byte: data[0].document_size_byte,
                productID: data[0].productID,
                url: data[0].url,
              });

              if (data[0].document_size_byte <= 999999) {
                Object.assign(productUpperDetails.value, {
                  size: (data[0].document_size_byte / 1024).toFixed(2) + "KB",
                });
              } else {
                Object.assign(productUpperDetails.value, {
                  size:
                    (data[0].document_size_byte / (1024 * 1024)).toFixed(2) +
                    "MB",
                });
              }
              if (
                productUpperDetails.value.document_content_type !== undefined ||
                productDeatilByProductIds.value.document_content_type !==
                undefined
              ) {
                if (
                  (productUpperDetails.value.document_content_type !==
                    undefined &&
                    productUpperDetails.value.document_content_type.match(
                      /flash/
                    ) !== null) ||
                  (productDeatilByProductIds.value.document_content_type !==
                    undefined &&
                    productDeatilByProductIds.value.document_content_type.match(
                      /flash/
                    ) !== null)
                ) {
                  imageType.value.is_flash = true;
                } else {
                  imageType.value.is_flash = false;
                }
                if (
                  (productUpperDetails.value.document_content_type !==
                    undefined &&
                    productUpperDetails.value.document_content_type.match(
                      /image/
                    ) !== null) ||
                  (productDeatilByProductIds.value.document_content_type !==
                    undefined &&
                    productDeatilByProductIds.value.document_content_type.match(
                      /image/
                    ) !== null)
                ) {
                  imageType.value.is_image = true;
                } else {
                  imageType.value.is_image = false;
                }
                if (
                  (productUpperDetails.value.document_content_type !==
                    undefined &&
                    productUpperDetails.value.document_content_type.match(
                      /html/
                    ) !== null) ||
                  (productDeatilByProductIds.value.document_content_type !==
                    undefined &&
                    productDeatilByProductIds.value.document_content_type.match(
                      /html/
                    ) !== null)
                ) {
                  imageType.value.html = true;
                } else {
                  imageType.value.html = false;
                }
              }
            }
          });
        })
        .catch(function (e) {
          if (error.response && error.response.status === 500) {
            console.error("Internal Server Error: ", error.message);
          } else {
            console.error("An error occurred: ", error.message);
          }
        });
    }

    function getMuid() {
      const apiurl = `${http.value.productmuid}`;
      const ids = [];
      ids.push(Number(productId.value));
      fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ product_ids: ids }),
      })
        .then((response) => {
          response.json().then(async (data) => {
            if (data[0] !== undefined) {
              mmuid.value = await Object.values(data[0]);
              if (
                productDeatilByProductIds.value.mChannelID === 3 &&
                (productDeatilByProductIds.value.mpanel_id === 1 ||
                  productDeatilByProductIds.value.mpanel_id === 2) &&
                mmuid.value !== undefined &&
                mmuid.value !== null
              ) {
                isWrench.value = true;
              } else {
                isWrench.value = false;
              }
            }
          });
        })
        .catch(function (e) {
          console.log(e);
        });
    }

    function printDetail() {
      window.print();
    }
    function commafy(num) {
      var nStr = num + "";
      nStr = nStr.replace(/\,/g, "");
      let x = nStr.split(".");
      let x1 = x[0];
      let x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      num = x1 + x2;
      return num;
    }
    function fetchAffinities(comptiId = penelistDetail.value.compti_id) {
      const apiurl = `${http.value.affinities}`;
      loadingCompetiscanID.value = true;
      affinitiesVal.value = "";
      loyaltyRetention.value = "";
      adderssChangeHistory.value = "";

      try {
        fetch(apiurl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ competi_id: comptiId }),
        }).then((res) => {
          res.json().then((response) => {
            if (response.status_code == 200) {
              if (response.data.Affinity_Names)
                affinitiesVal.value = response.data.Affinity_Names.toString();
              if (response.data.Company_Names)
                loyaltyRetention.value = response.data.Company_Names.toString();
              if (response.data.AddressChangeHistory)
                adderssChangeHistory.value =
                  response.data.AddressChangeHistory.toString();
            }
            loadingCompetiscanID.value = false;
          });
        });
        competiIDPopup.value = true;
      } catch (e) {
        loadingCompetiscanID.value = false;
        return e;
      }
    }

    function getPrintDetailName(printDetail) {
      let printDetailName = [];
      printDetail.forEach((item) => {
        if (!printDetailName.includes(item.print_typeName)) {
          printDetailName.push(item.print_typeName);
        }
      });
      return printDetailName;
    }

    function getAffinityCategory(affinityCategory) {
      let affinityCategoryName = [];
      let affinityCat = affinityCategory.split(",");

      affinityCat.forEach((item) => {
        if (!affinityCategoryName.includes(item)) {
          affinityCategoryName.push(item.trim());
        }
      });

      return affinityCategoryName.toString();
    }
    watch(isQaCerified, async (newVal, oldVal) => {
  if (oldVal === null) return;
  isLoading.value = true;
  try {
    await fetch(config.UpdateQA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_id: Number(productId.value),
        is_qa: newVal ? 1 : 0,
      }),
    });
  } catch (e) {
    console.error("QA update failed", e);
  }
  isLoading.value = false;
});
    return {
      getAffinityCategory,
      affinitiesVal,
      fetchAffinities,
      loyaltyRetention,
      getMuid,
      valuescore,
      commafy,
      dtsVal,
      getImageAndSize,
      productBasicDeatails,
      headlineHover,
      highlightedIndex,
      openAnalysis,
      filterSpend,
      openInternalModal,
      valueScoreVals,
      openPDF,
      openHtmlTag,
      openAiAnalysis,
      isHovering,
      isHoveringCompetiID,
      isHoveringExternalLink,
      isHoveringEntryId,
      isHoveringPrintDetails,
      isHoveringPrintAll,
      isHoveringPrintPdf,
      isHoveringAdd,
      competiIDPopup,
      isHoveringHtml,
      img,
      htmlPath,
      productDeatilByProductIds,
      productDeatilByProductIdsRes,
      isHoveringSendLink,
      isHoveringQAlink,
      isHoveringProductContent,
      openPdfContent,
      openPdfContentFunction,
      isQaCerified,
      remBor,
      removeBorders,
      subSubCategoryPresent,
      catsSections,
      isPublication,
      penelistDetail,
      panelistCompetiIds,
      panelistPageNumber,
      panelistPageSize,
      panelistTotalRecords,
      panelistTotalPages,
      isPanelistLoading,
      showFicoScore,
      showCreditVision,
      showVantageScore,
      hasScoreValue,
      fetchPanelistDetails,
      changePanelistPage,
      filterPenelistDetail,
      closeWindow,
      isCloseWindow,
      isHoveringSpend,
      isLoading,
      openEntryId,
      getImageVideoPdf,
      http,
      videoSrc,
      productViews,
      openVideo,
      openV1Links,
      imageType,
      panalistDetails,
      isTraffic,
      valueScoreModal,
      productId,
      trackingId,
      updateEmailTracking,
      productUpperDetails,
      isAnimation,
      isWrench,
      showAiAnalysis,
      mmuid,
      emvAndevmPopup,
      spendPopup,
      additionalPopup,
      publicationPopupBox,
      publicationTypeName,
      trafficPopupBox,
      printAll,
      logo,
      printDetail,
      getPrintDetailName,
      loadingCompetiscanID,
      affinityCategoryVal,
    };
  },
};
</script>

<style scoped>
.product-image {
  border: 1px solid black;
  padding-bottom: 0%;
  vertical-align: middle !important;
  overflow-clip-margin: content-box;
  overflow: clip;
  width: 152px;
  height: 102px;
}

.v-table--density-default>.v-table__wrapper>table>tbody>tr>td,
.v-table--density-default>.v-table__wrapper>table>thead>tr>td,
.v-table--density-default>.v-table__wrapper>table>tfoot>tr>td {
  height: calc(var(--v-table-row-height, 0px) + 25px) !important;
}

.v-table>.v-table__wrapper>table>tbody>tr>td,
.v-table>.v-table__wrapper>table>tbody>tr>th,
.v-table>.v-table__wrapper>table>thead>tr>td,
.v-table>.v-table__wrapper>table>thead>tr>th,
.v-table>.v-table__wrapper>table>tfoot>tr>td,
.v-table>.v-table__wrapper>table>tfoot>tr>th {
  padding: 0 2px !important;
}

.link-color {
  color: #00a4e4;
  cursor: pointer;
  text-decoration: none;
}

.link-color-changes {
  color: black;
  cursor: pointer;
  text-decoration: none;
}

.underline {
  color: #000099;
  text-decoration: underline;
}

.div-margin {
  margin-left: 5px;
}

.table-border {
  border: 1px solid blue;
}

.rw-col {
  display: flex;
  flex-wrap: wrap;
}

.highlight-month {
  background-color: #0055e3;
  color: #ffffff;
  font-weight: bold;
  border: 1px solid white;
}

.v-row.v-row--no-gutters>.v-col,
.v-row.v-row--no-gutters>[class*="v-col-"] {
  padding: 4px 0 4px 4px !important;
}

.flex {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin: 2em;
}

.flex>div {
  flex: 1 1 40%;
}

.v-container {
  min-width: 100%;
}

.v-col {
  font-size: 12px;
}

.styling-rows-cols {
  border-bottom: 1px red dotted;
  padding-bottom: 5px;
}

.item+.item:before {
  content: ", ";
}

.modal-body {
  overflow-y: auto;
  max-height: 500px;
}

.modal-publication-body {
  overflow-y: auto;
  max-height: 200px;
}

.modal {
  align-items: center;
  display: flex;
  margin-top: 30px;
  /* justify-content: center; */
  /* position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0; */
  /* background: rgba(254, 126, 126, 0.7); */
  transition: all 0.4s;
  /* visibility: hidden;
  opacity: 0; */
}

.content {
  position: absolute;
  background: white;
  width: 300px;
  padding: 1em 5px;
  border-radius: 4px;
  border: 2px solid black;
}

.content-additonal {
  position: absolute;
  background: white;
  width: 350px;
  padding: 1em 0em;
  border-radius: 4px;
  border: 2px solid black;
  max-height: 55%;
  overflow-y: auto;
}

.spend_content {
  position: absolute;
  background: white;
  width: 700px;
  padding: 1em 0em;
  border-radius: 4px;
  left: 8%;
  top: 31%;
  border: 2px solid black;
}

.content-email {
  position: absolute;
  background: white;
  border-radius: 4px;
  border: 2px solid black;
  width: 635px;
  left: 16%;
  top: 22%;
  padding: 14px 0px 1px 8px;
}

.content-email-body {
  padding: 0px 6px 0px 0px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
}

.content-email-body-valuescore {
  position: absolute;
  background: white;
  width: 300px;
  top: 69%;
  padding: 1em 0em;
  border-radius: 4px;
  border: 2px solid black;
}

.modal:target {
  visibility: visible;
  opacity: 1;
}

.box-close {
  position: absolute;
  top: 0;
  right: 15px;
  color: #00a4e4;
  text-decoration: none;
  font-size: 12px;
}

.set-font {
  font-family: "Times New Roman";
}

.set-emv-font {
  font-family: arial !important;
  font-size: 10px !important;
}

.publication-content-font-body {
  font-family: arial;
  font-size: 10px;
  color: #505050;
  text-decoration: none;
  line-height: 18px;
}

.modal-traffic-source-body {
  overflow-y: auto;
  max-height: 200px;
}

strong {
  font-weight: bolder;
  /* font-size: 12px; */
  font-family: "Times New Roman";
  color: #505050;
}

span {
  font-family: "Times New Roman";
}

.hover-link{
  color: #00a4e4;
  cursor: pointer;
  text-decoration: none;
}
.hover-link:hover{
  color: black;
}
</style>